import { useNls } from '../../nls/nlsProvider'
import { useFamilyAccess } from '../../hooks/useFamilyAccess'
import { useWorkspace } from '../../context/useWorkspace'
import { requestWorkspaceSwitch } from '../../services/workspaceSwitchService'
import { FamilyShell } from './FamilyShell'
import { FamilyStatePage } from './FamilyStatePage'
import { Button } from '../Common'

export const FamilyEntry = () => {
  const { t } = useNls()
  const { status, learners, isFamilyOnly, refresh } = useFamilyAccess()
  const { workspaces, getWorkspaceRole, rolesByWorkspaceId } = useWorkspace()

  const nonPreviewWorkspaces = (workspaces || []).filter((w) => !w.isPreview)
  const firstStaffWorkspace = nonPreviewWorkspaces.find((w) => {
    const role = getWorkspaceRole ? getWorkspaceRole(w.id) : rolesByWorkspaceId?.get(w.id)
    return role && role !== 'LEARNER'
  })

  const handleOpenStaffWorkspace = () => {
    if (firstStaffWorkspace) {
      void requestWorkspaceSwitch({
        toWorkspaceId: firstStaffWorkspace.id,
        source: 'USER',
        landing: '/',
      })
    }
  }

  if (status === 'loading') {
    return (
      <FamilyStatePage
        body={t('NLSFamilyLoading')}
        ariaLabel={t('NLSFamilyAriaLoading')}
      />
    )
  }

  if (status === 'error') {
    return (
      <FamilyStatePage
        tone="danger"
        title={t('NLSFamilyErrorTitle')}
        body={t('NLSFamilyErrorBody')}
        actions={
          <Button variant="secondary" size="sm" onClick={refresh}>
            {t('NLSFamilyRetry')}
          </Button>
        }
        ariaLabel={t('NLSFamilyAriaError')}
      />
    )
  }

  if (learners.length === 0) {
    const handleJoinClick = () => {
      if (typeof window !== 'undefined') {
        window.history.pushState(null, '', '/join')
        window.dispatchEvent(new PopStateEvent('popstate'))
      }
    }

    return (
      <FamilyStatePage
        title={t('NLSFamilyEmptyTitle')}
        body={t('NLSFamilyEmptyBody')}
        actions={
          <>
            <Button variant="primary" size="md" onClick={handleJoinClick}>
              {t('NLSFamilyJoinWithCode')}
            </Button>
            {!isFamilyOnly && firstStaffWorkspace && (
              <Button variant="secondary" size="md" onClick={handleOpenStaffWorkspace}>
                {t('NLSFamilyOpenStaffWorkspace')}
              </Button>
            )}
          </>
        }
        ariaLabel={t('NLSFamilyAriaEmpty')}
      />
    )
  }

  return <FamilyShell learners={learners} />
}
